import { Link } from '@tanstack/react-router';
import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';
import { Button } from '@nucleus-commerce/ui/components/button';

import { session } from '@/shared/session/session';

import { EmailCard } from '../components/email-card';
import { PasswordCard } from '../components/password-card';
import { ProfileCard } from '../components/profile-card';
import { SessionsCard } from '../components/sessions-card';

function Account() {
  const { t } = useTranslation('account');
  const { me } = session.useSession();
  if (!me) return null;
  return (
    <PageContent>
      <PageHeader
        title={t('title')}
        description={t('description')}
        actions={
          <Button asChild variant="outline" data-tour="account.security-link">
            <Link to="/account/security">
              <ShieldCheck aria-hidden />
              {t('security')}
            </Link>
          </Button>
        }
      />
      <div className="flex max-w-3xl flex-col gap-6">
        <ProfileCard key={me.user.id} me={me} />
        <EmailCard email={me.user.email} />
        <PasswordCard />
        <SessionsCard />
      </div>
    </PageContent>
  );
}

/** The signed-in person's own account: profile, sign-in email, password and devices. */
export function AccountPage() {
  return (
    <FeatureErrorBoundary name="account">
      <Account />
    </FeatureErrorBoundary>
  );
}
